module.exports = __webpack_public_path__ + "img/content-bg.f30f9707.png";